import React from "react";
import "./onboardFormTextLg.scss";
const OnboardFormTextLg = ({ txt }) => (
  <span className="onboard-form-text-lg">{txt}</span>
);

export default OnboardFormTextLg;
